import { styled } from '@linaria/react';

export const CountriesFilterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
